





























































































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { EmailTemplateHtmlProperty, EmailTemplateSendRequest } from "@/admin/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import FileUpload from "vue-upload-component";
import { Validator } from "vee-validate";
import { useNotifierStore } from "@/shared/store/notifier";
import { useEmailTemplateStore } from "@/admin/store/emailTemplateStore";

@Component({
  components: {
    FileUpload,
    GenericLoadingSpinner
  }
})
export default class AdminEmailTemplateUtility extends Vue {
  $validator: Validator;
  notifierStore = useNotifierStore();
  emailTemplateStore = useEmailTemplateStore();
  selectedTemplate = "";
  emailAddress = "";
  showModalForm = false;
  partnerId = 0;
  isSubmitting = false;
  exclude = new Set(["SubjectPart", "BankDivision", "LogoUrl", "CurrentYear", "PartnerName", "PartnerSupportWebsite", "FromEmail", "PartnerSupportPhone", "ButtonColor", "ButtonTextColor"]);

  created () {
    this.emailTemplateStore.getAdminEmailTemplates();
  }
  get isLoading () {
    return !this.emailTemplateStore.isLoaded;
  }
  get tableFields () {
    return this.emailTemplateStore.emailTemplates ? this.emailTemplateStore.emailTemplates : [];
  }
  onChange () {
    if (this.selectedTemplate) {
      this.emailTemplateStore.getAdminEmailTemplateDetail(this.selectedTemplate);
    } else {
      this.emailTemplateStore.resetEmailTemplate();
    }
  }
  get htmlContent () {
    return this.emailTemplateStore.htmlContent;
  }
  get emailSubject () {
    return this.emailTemplateStore.emailSubject;
  }
  get htmlProperties () {
    return this.emailTemplateStore.parameters;
  }
  get canSendTestEmail (): boolean {
    return this.emailTemplateStore.canSendTestEmail;
  }
  onShowModal () {
    this.showModalForm = true;
  }
  onSendTestEmail () {
    if (this.isSubmitting) { return; }
    this.$validator.validate()
        .then(result => {
          if (result) {
            this.showModalForm = false;
            this.isSubmitting = true;
            const propsCount: number = this.filteredProperties.length;
            const userResponses: EmailTemplateHtmlProperty[] = this.filteredProperties.map(x => {
              if (x.value) {
                return x;
              }
            });
            if (propsCount !== userResponses.length) {
              return;
            }
            const formModel: EmailTemplateSendRequest = {
              partnerId: this.partnerId,
              templateName: this.selectedTemplate,
              email: this.emailAddress,
              parameters: userResponses
            };
            return this.emailTemplateStore.postAdminEmailTemplateTest(formModel);
          }
        })
        .finally(() => {
          this.isSubmitting = false;
        });
  }
  onClose () {
    this.showModalForm = false;
  }
  get sendQuotas () {
    return this.emailTemplateStore.sendQuotas;
  }
  get partners () {
    return this.emailTemplateStore.partners ? this.emailTemplateStore.partners : [];
  }
  get filteredProperties () {
    return this.htmlProperties.filter(x => !this.exclude.has(x.propertyname));
  }
}
